<template>
  <div class="mobile-wrapper" v-if="storeMenu && getloadedMenu">
    <!--Coupons-->
    <shop-header
      @show-reorder="u=>isShowReorder = u"
      @show-search="showSearchBox = true"
      :showPopular="isShowPopular"
      :showSearchBox="showSearchBox"
      :menu="JSON.parse(JSON.stringify(storeMenu))"
      :store-id="storeid"
      :categories="storeMenu.Categories"
      @filterText="filterTextchange"
    />
    <div class="content-padding-double" :style="{'height':`${getHeight}px`}" />
    <div class="container-fluid mobile-menu-content">
      <ProductList
        :menu="JSON.parse(JSON.stringify(storeMenu))"
        @show-search="showSearchBox = false"
        @show-popular="setPopularVisibility"
        :showSearchBox="showSearchBox"
        :filterText="filterText"
        :show-reorder="isShowReorder"
      />
    </div>
  </div>
</template>
<script>
import ProductList from "./products/ProductListMobile";
import ShopHeader from "./partials/shopheaderMobile";
import { mapMutations, mapActions, mapGetters } from "vuex";
import sharedScripts from '../../sharedscripts/shop/Shop';
import HomePageMobile from './homePageMobile.vue';

export default {
  components: {
    ProductList,
    ShopHeader,
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  mixins: [HomePageMobile],
  data() {
    return {
      showSearchBox: false,
      isShowPopular: true,
      isShowReorder: true,
      filterText:"",
    };
  },
  async created() {
    if(this.currentStoreDoc && this.storeid != this.currentStoreDoc.ID)
    {
      this.setCurrentStoreDoc(null);
    }
    this.initPriceTriggers(this.storeid);
  },
  mounted() {
    const self = this;
    this.setStore(this.storeid);
    this.initStore({
      storeId: this.storeid,
      callback: () => {
        self.initiateWorkflow();
      },
    });
    this.getStoreMenu(this.storeid);
    if (!sessionStorage.getItem("paymenttype")) {
      sessionStorage.setItem(
        "paymenttype",
        new URLSearchParams(window.location.search).get("paymenttype")
      );
    }
    this.updateShoppingCartItems();
  },
  computed: {
    ...sharedScripts.computed,
    ...mapGetters(["storeMenu", "getloadedMenu", "selectedCompany", "currentStoreDoc"]),
    getHeight() {
      var result = (!this.isShowPopular && this.isShowReorder) ? 334 : 158;
      
      // if (this.showSearchBox) {
      //   result -= 50;
      // }
      return result;
    }
  },
  watch: {
    ...sharedScripts.watch,
  },
  methods: {
    ...sharedScripts.methods,
    ...mapMutations(["setStore","setCurrentStoreDoc"]),
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "insertErrorlog",
      "redirectToErrorPage",
      "initPriceTriggers",
      "updateShoppingCartItems"
    ]),
    filterTextchange (txt){
      this.filterText = txt;
    },
    setPopularVisibility(isVisible) {
      this.isShowPopular = isVisible;
    }
  }
};
</script>
